<template>
    <component :is="homeComponentName" />
</template>

<script>
export default {
    name: 'home-view',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';
import router from '@/router';
//import enviromentStore from '@/store/enviroment-data';
import { getUserApps } from '@/store/global';

//\|todo Из url получит appId
//todo с сервера получить массив соответствий appId - component
//todo найти имя компонента для home по appId
//todo отобразить компонент соответствующий appId
const appId = ref();
// const { getAppList } = enviromentStore;
// const { state } = enviromentStore;
const homeComponentName = ref('home-view-def');
onMounted(async () => {
    appId.value = Number.parseInt(router.currentRoute.value.params.app);

    const appsResp = await getUserApps();
    const app = appsResp.items.find(item => item.kod_app === appId.value);
    if (app.settings?.home_component !== undefined) {
        homeComponentName.value = app.settings.home_component;
    }
});
</script>
<style scoped></style>
